export const getSimulationState = store => store.simulation;

export const getWorkspacesState = store => getSimulationState(store).workspaces;

export const getRunsListState = store => getSimulationState(store).runs;

export const getScenariosState = store => getSimulationState(store).scenarios;

export const getLimitsState = store => getSimulationState(store).limits;

export const getRunState = store => getSimulationState(store).run;

export const getComparisonState = store => getSimulationState(store).comparison;

export const getRunToCopyState = store =>
    getSimulationState(store).runToCopy;
